var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{attrs:{"image":"error","description":"未获取到用户信息"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }